/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>More help</h4>

<p>We love helping our users. Click to reach out...</p>`;

export default function HelpmeTooltip() {
    return h('div', { innerHTML: body });
}
